import { render, staticRenderFns } from "./PgaActivitiesListItems.vue?vue&type=template&id=2a921bcc&"
import script from "./PgaActivitiesListItems.vue?vue&type=script&lang=ts&"
export * from "./PgaActivitiesListItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a921bcc')) {
      api.createRecord('2a921bcc', component.options)
    } else {
      api.reload('2a921bcc', component.options)
    }
    module.hot.accept("./PgaActivitiesListItems.vue?vue&type=template&id=2a921bcc&", function () {
      api.rerender('2a921bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Activity/Components/PgaActivitiesListItems.vue"
export default component.exports